<template>
  <div>
    <v-card class="rounded-lg white">
      <v-card-title class="secondary--text">
        {{ title }}
        <v-spacer></v-spacer>
        <v-col cols="1">  
        <v-btn color="primary" small class="mb-2" @click="openChargeDialog">
          شارژ کیف پول
        </v-btn>
      </v-col>
      </v-card-title>
      <v-card-text>
        <m-datatable
          :show-select="false"
          :show-filter-row="false"
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
          ref="datatable"
        >
          <template v-slot:item.actions="{ item }">
            <template v-if="item.status === 'pending'">
              <v-btn small class="ml-2" color="success" @click="approveRequest(item)">
                تایید
              </v-btn>
              <v-btn small color="error" @click="openRejectDialog(item)">
                رد
              </v-btn>
            </template>

            <template v-if="item.status === 'approved'">
              <v-btn small color="primary" @click="markAsPaid(item)">
                علامت‌گذاری به عنوان پرداخت شده
              </v-btn>
            </template>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
    <v-dialog v-model="rejectDialog.show" persistent max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h5">رد درخواست برداشت</span>
        </v-card-title>
        <v-card-text v-if="rejectDialog.item">
          <p>
            شما در حال رد کردن درخواست برداشت مبلغ
            <strong>{{ rejectDialog.item.amount | toMoney }} ریال</strong>
            برای کاربر
            <strong>{{ rejectDialog.item.user.name }}</strong>
            هستید.
          </p>
          <v-textarea
              v-model="rejectDialog.reason"
              label="دلیل رد کردن (الزامی)"
              required
              outlined
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="rejectDialog.show = false">
            انصراف
          </v-btn>
          <v-btn color="error" text @click="confirmRejectRequest">
            تایید و رد کردن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog v-model="chargeDialog.show" persistent max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h5">شارژ کیف پول کاربر</span>
        </v-card-title>
        <v-card-text>
          <v-row class="ma-2">
            <v-col cols="12">  
              <v-text-field
                  v-model="chargeDialog.phone"
                  label="شماره تماس کاربر"
                  outlined
                  required
              ></v-text-field>
              </v-col>
              <v-col cols="12">
                <money
                  v-model="chargeDialog.amount"
                  label="مبلغ (ریال)"
                  outlined
                  required
              />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="chargeDialog.explanation"
                  label="توضیحات"
                  outlined
                ></v-textarea>
              </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="chargeDialog.show = false">انصراف</v-btn>
          <v-btn text color="success" @click="confirmChargeWallet">تایید و شارژ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="chargeResult.show" max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title class="text-h6">نتیجه شارژ کیف پول</v-card-title>
        <v-card-text v-if="chargeResult.data">
          <p><strong>{{ chargeResult.data.detail }}</strong></p>
          <p>شناسه تراکنش: {{ chargeResult.data.transaction_id }}</p>
          <p>کاربر: {{ chargeResult.data.phone }} (ID: {{ chargeResult.data.user_id }})</p>
          <p>مبلغ شارژ: {{ chargeResult.data.amount }} ریال</p>
          <p>موجودی جدید: {{ chargeResult.data.new_balance }} ریال</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="chargeResult.show = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  name: "WithdrawalManagement",
  data() {
    return {
      filters: {},
      rejectDialog: {
        show: false,
        item: null,
        reason: ''
      },
      chargeDialog: {
        show: false,
        phone: "",
        amount: "",
        explanation: ""
      },
      chargeResult: {
        show: false,
        data: null
      },
    };
  },
  computed: {
    title() {
      return "مدیریت کیف پول و درخواست های برداشت";
    },
	  url() {
      return "sobhanAdmin/withdrawal-requests/";
    },
    headers	() {
      return [
        {
					text: "نام کاربر",
					value: "user.name",
					sortable: false
				},
	      {
					text: "شماره تماس کاربر",
					value: "user.phone",
					sortable: false
				},
        {
					text: "مبلغ (ریال)",
					value: "amount",
					type: "numeric"},
        {
					text: "شماره کارت",
					value: "card_number",
					sortable: false},
        {
					text: "وضعیت", 
					value: "status",
	        type: "select",
          items: [
            {
              'text': 'در انتظار',


              'value': 'pending'
            },
            {
              'text': 'تایید شده',
              'value': 'approved'
            },
            {
              'text': 'رد شده',
              'value': 'rejected'
            },
            {
              'text': 'پرداخت شده',
              'value': 'paid'
            },
          ]
				},
        {
          text: "تاریخ درخواست",
          value: "created_at",
          type: "datetime"
        },
        {
          text: "تاریخ پردازش",
          value: "processed_at",
          type: "datetime"
        },
        {
          text: "توضیحات (دلیل رد)",
          value: "explanation",
          sortable: false
        },
        {
          text: "عملیات",
          value: "actions",
          sortable: false,
          align: 'center'
        }
      ];
    },
  },
  methods: {
    openChargeDialog() {
      this.chargeDialog = { show: true, phone: "", amount: "", explanation: "" };
    },
    approveRequest(item) {
      const url = this.endpoint(`${this.url}/${item.id}/approve/`);
      this.request({
        url: url,
        method: 'post',
        success: (data) => {
          this.notify('درخواست با موفقیت تایید شد.', 'success');
          this.$refs.datatable.getDataFromApi();
        }
      });
    },

    openRejectDialog(item) {
      this.rejectDialog.item = item;
      this.rejectDialog.reason = '';
      this.rejectDialog.show = true;
    },

    confirmRejectRequest() {
      if (!this.rejectDialog.reason) {
        this.notify('نوشتن دلیل برای رد کردن درخواست الزامی است.', 'danger');
        return;
      }
      const item = this.rejectDialog.item;
      const url = this.endpoint(`${this.url}/${item.id}/reject/`);
      this.request({
        url: url,
        method: 'post',
        data: {reason: this.rejectDialog.reason},
        success: (data) => {
          this.notify('درخواست با موفقیت رد شد.', 'success');
          this.rejectDialog.show = false;
          this.$refs.datatable.getDataFromApi();
        }
      });
    },
    markAsPaid(item) {
      const url = this.endpoint(`${this.url}/${item.id}/mark-as-paid/`);
      this.request({
        url: url,
        method: 'post',
        success: (data) => {
          this.notify('وضعیت درخواست به "پرداخت شده" تغییر یافت.', 'success');
          this.$refs.datatable.getDataFromApi();
        }
      });
    },
    confirmChargeWallet() {
      if (!this.chargeDialog.phone || !this.chargeDialog.amount) {
        this.notify("شماره و مبلغ الزامی هستند", "danger");
        return;
      }
      const url = this.endpoint("sobhanAdmin/charge-wallet/");
      this.request({
        url,
        method: "post",
        data: {
          phone: this.chargeDialog.phone,
          amount: this.chargeDialog.amount,
          explanation: this.chargeDialog.explanation
        },
        success: (data) => {
          this.chargeDialog.show = false;
          this.chargeResult.data = data;
          this.chargeResult.show = true;
          this.$refs.datatable.getDataFromApi();
        }
      });
    },
  }
};
</script>